import { RECENTLY_VIEWED_ITEM_IDS } from 'tradera/constants/cookies';
import cookieUtil from 'tradera/utils/cookie';

export const getInitialState = (initData) => {
    const wishListItemIds = new Set(initData.wishListItemIds || []);
    const recentItemIds =
        cookieUtil
            .readCookie(RECENTLY_VIEWED_ITEM_IDS)
            ?.split(';')
            .filter(Boolean)
            .map(Number) ?? [];

    return {
        recentItemIds,
        wishListItemIds: Array.from(wishListItemIds)
    };
};
